export const iconFontAwesomeUsersPeopleUserInjured = (
	<i className="fa-solid fa-user-injured"></i>
);
